var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"team_operate container"},[_c('div',{staticClass:"header"},[_c('el-page-header',{attrs:{"content":_vm.isSet ? '创建团队' : '加入团队'},on:{"back":_vm.back}})],1),_c('div',{staticClass:"main"},[(_vm.isSet)?_c('set-team',{on:{"back":_vm.back}}):_c('join-team',{on:{"back":_vm.back}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }